import { useMemo, useState } from "react";

import { AppSearchInput } from "../../../shared/ui/search-input";
import { SmartTable } from "../../../shared/ui/smart-table";
import {
  TableCard,
  TableContent,
  TableDescription,
  TableHeader,
  TableTitle,
} from "../../alerted-products-table/ui/AlertedProductsTableWidget.styles";
import { AlertedProductsFiltersWidget } from "../../alerted-products-filters";
import { useCentralizationData } from "../model/useCentralizationData";
import { getCentralizationColumns } from "../model/getCentralizationColumns";
import { CentralizationDetail } from "./CentralizationDetail";

const TABLE_SCROLL_X = 1360;
const TABLE_EMPTY_TEXT =
  "No hay productos con gestión de alerta resuelta para los filtros aplicados.";

export const AlertedProductsCentralizationWidget = () => {
  const data = useCentralizationData();
  const [selectedRecord, setSelectedRecord] = useState(null);

  const shouldShowTable = data.tableLoading || Boolean(data.appliedFilters);

  const columns = useMemo(
    () =>
      getCentralizationColumns(
        data.managementTypeOptions,
        data.alertManagementOptions,
        {
          onDetails: (record) => setSelectedRecord(record),
        }
      ),
    [data.managementTypeOptions, data.alertManagementOptions]
  );

  if (selectedRecord) {
    return (
      <CentralizationDetail
        record={selectedRecord}
        journeyId={data.appliedFilters?.operationalDay?.value}
        onBack={() => setSelectedRecord(null)}
      />
    );
  }

  return (
    <>
      <AlertedProductsFiltersWidget
        loading={data.tableLoading}
        onApply={data.applyFilters}
        onReset={data.resetFilters}
        onJourneyChange={data.changeJourney}
        initialFilters={data.appliedFilters}
        showAlertManagementFilter={false}
      />

      {shouldShowTable ? (
        <TableCard bordered={false} style={{ marginTop: 16 }}>
          <TableHeader>
            <TableTitle>Centralización</TableTitle>
            <TableDescription>
              Productos alertados cuya gestión de alerta se encuentra resuelta.
            </TableDescription>
          </TableHeader>

          <TableContent>
            <SmartTable
              loading={data.tableLoading}
              rowKey="id"
              columns={columns}
              columnWidthMode="fixed"
              dataSource={data.tableDataSource}
              total={data.totalRecords}
              currentPage={data.currentPage}
              pageSize={data.pageSize}
              onPageChange={data.changePage}
              enableRowSelection={false}
              showPagination
              pageSizeOptions={["10", "20", "50"]}
              defaultPageSize="10"
              showToolbar
              showColumnSettings={false}
              showTableResize={false}
              showReload={false}
              download={{ enable: false }}
              leftContent={
                <AppSearchInput
                  value={data.searchValue}
                  onChange={(e) => data.setSearchValue?.(e.target.value)}
                  placeholder="Buscar por proveedor, ID producto, orden o titular"
                  disabled={data.tableLoading}
                  style={{ width: 480 }}
                />
              }
              emptyText={TABLE_EMPTY_TEXT}
              scroll={{ x: TABLE_SCROLL_X, y: undefined }}
            />
          </TableContent>
        </TableCard>
      ) : null}
    </>
  );
};